import { AppState } from '../../../types/store';
import { TimeslotsStore } from '../../models/timeslots';

export const timeslotsSelector = (state: AppState): TimeslotsStore => state.timeslots;
